import StayCard from "components/StayCard/StayCard";
import { DEMO_STAY_LISTINGS } from "data/listings";
import React, { FC, useState, Fragment } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import CommonLayout from "./CommonLayout";

import { ListingDataType, AuthorType } from "data/types";
import PropertyCard from "components/PropertyCardH/PropertyCard";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Dialog, Transition } from "@headlessui/react";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import Textarea from "shared/Textarea/Textarea";

import Avatar from "shared/Avatar/Avatar";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import ButtonSquareFull from "shared/Button/ButtonSqareFull";
import Overview from "containers/ListingDetailPage/listing-stay-detail/Overview";
import FactsFeatures from "containers/ListingDetailPage/listing-stay-detail/FactsFeatures";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import type { ListingGalleryImage } from "../../components/ListingImageGallery/utils/types";
import Modal from "../../components/ListingImageGallery/components/Modal";
import { useAuth0 } from "@auth0/auth0-react";
import axios from 'axios';

export interface PageAddListing10Props {}

const PageAddListing10: FC<PageAddListing10Props> = () => {

  const { user, isAuthenticated } = useAuth0();

  let [isOpenModalDetails, setIsOpenModalDetails] = useState(false);
let [isOpenModalTour, setIsOpenModalTour] = useState(false);
let [isOpenModalContact, setIsOpenModalContact] = useState(false);
let [isTypePerson, setIsTypePerson] = useState(true);
let [isOpenGallery, setIsOpenGallery] = useState(false);
let [propertyImage, setPropertyImage] = useState<ListingGalleryImage[]>();
  // const [startDate, setStartDate] = useState(new Date());
const [startDate, setStartDate] = useState<Date | null>(null);
const [modalPropertyData, setModalPropertyData] = useState<ListingDataType>();
const [author, setAuthor] = useState<AuthorType>();

const navigate = useNavigate();

const location = useLocation();
// const propertyInfo = location.state;
// const agent = propertyInfo.agent as AuthorType;
const property = location.state as ListingDataType;

function openModalDetails() {
  setIsOpenModalDetails(true);
}

function closeModalDetails() {
  setIsOpenModalDetails(false);
}


const handleClick = (info: ListingDataType ) => {
 
  setModalPropertyData(info);
  setAuthor(info.author);
  const smallScreenBreakpoint = 768; 
   if (window.innerWidth <= smallScreenBreakpoint) {
      navigate('/mobile-detail', { state: info });
   } else {
     openModalDetails();
   }
};

function closeModalTour() {
  setIsOpenModalTour(false);
}

function changeTypePerson() {
  setIsTypePerson(true);
}

function changeTypeVideo() {
  setIsTypePerson(false);
}

function openModalTour() {
  setIsOpenModalTour(true);
}

function openModalContact() {
  setIsOpenModalContact(true);
}

function closeModalContact() {
  setIsOpenModalContact(false);
}


const toReview = async () => {
  // if (property.factsFeatures) {
  //    property.factsFeatures.appliances = appliances.split(',').map(item => item.trim()); 
  //    property.factsFeatures.interior = interior.split(',').map(item => item.trim()); 
  //    property.factsFeatures.otherInterior = exterior.split(',').map(item => item.trim()); 
  // }

// const propertyInfo = {
//   property,
//   agent,
// };
// navigate('/add-listing-10', { state: propertyInfo });
console.log(property);
// const updateAgentData = async () => {
  // Here, prepare the updatedAgentData with the required payload to send to the API

  const userId = user && user.sub;
  if (userId) {
      const cleanUserId = userId.replace('auth0|', '');
      // const decodedUserId = encodeURIComponent(userId); // Encoding the user_id

      axios.post(process.env.REACT_APP_API +`property/agent/${cleanUserId}`, property)
          .then((response) => {
            navigate('/listing-profile');
          })
          .catch((error) => {
              // Handle any errors here
              console.error('Error fetching properties:', error);
          });
//  }
};

}

const toEdit = () => {
  const agent = property.author;
  const propertyInfo = {
    property,
    agent,
  };

navigate('/add-listing-1', { state: propertyInfo });
}

const toPrevtStep = () => {

  const agent = property.author;
  const propertyInfo = {
    property,
    agent,
  };

navigate('/add-listing-7', { state: propertyInfo });
}

  // const DEMO_LISTINGS: ListingDataType = 
  //   {
  //     "id": "id1",
  //     "author":  {
  //       "id": 1,
  //       "firstName": "Tony",
  //       "lastName": "Stark",
  //       "displayName": "-",
  //       "email": "tonystark0@gmail.com",
  //       "avatar": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmdU20JbK_Fv68F2pkt3ODsftZrI3VnqJwvnG_R06PFfPo19r-HNuSGRWZrFwFYw3is3Q&usqp=CAU",
  //       "bgImage": "https://images.pexels.com/photos/4064835/pexels-photo-4064835.jpeg?auto=compress&cs=tinysrgb&w=500",
  //       "count": 40,
  //       "reviewStart": 4.8,
  //       "reviewCount": 28,
  //       "language": "English, Spanish",
  //       "href": "/author",
  //       "desc": "There’s no stopping the tech giant. Apple now opens its 100th store in China.There’s no stopping the tech giant.",
  //       "jobName": "Author Job",
  //       "company": "Test Company",
  //       "joindate": "10/10/2023",
  //       "facebook": "url",
  //       "twitter": "url",
  //       "youtube": "url",
  //       "instagram": "url"
  //     },
  //     "date": "May 20, 2021",
  //     "title": "LUXURIOUS AND MODERN HOUSE FOR SALE",
  //     "featuredImage": "https://s3.rea.global/img/1208x680-prop/realtor/do/41d52c2d95ca6c168c057842162a9884.jpg",
  //     "galleryImgs": [
  //       "https://images.pexels.com/photos/1268871/pexels-photo-1268871.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
  //       "https://images.pexels.com/photos/1179156/pexels-photo-1179156.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
  //       "https://images.pexels.com/photos/2506988/pexels-photo-2506988.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
  //       "https://images.pexels.com/photos/2373201/pexels-photo-2373201.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
  //     ],
  //     "viewCount": 602,
  //     "like": false,
  //     "address": "Punta Cana, Punta Cana, La Altagracia Province",
  //     "price": "$5,072,588",
  //     "type": "House",
  //     "bedrooms": 3,
  //     "bathrooms": 3,
  //     "mainFeatures": ["condominium", "Built in 1968", "Forced air, radiator, oil", "2 Garage Spaces", "$2,042 Monthly", "$261 price/sqft"],
  //     "sqrft":1345,
  //     "saleOff": "-10% today",
  //     "isAds": null,
  //     "isRental": false,
  //     "overview": {
  //       "description": "Welcome to 779 prospect Ave PH, the largest penthouse in the Hartford area! This Luxurious 3 beedroom/2.5 bathroom condo has everything you could want or need to entertain! Enjoy over 3,400 sq ft of indoor living space",
  //       "openDate": "02/02/2023",
  //       "openHour": "12:00 PM - 2:00 PM",
  //       "sourceMls": "Smart MLS",
  //       "mls": "170546053",
  //       "lastUpdate": "02/02/2023",
  //       "map": { "lat": -33.8569, "lng": 151.2152 }
  //     },
  //     "factsFeatures":{
  //       "bedrooms": ["Bedrooms: 5","Bathrooms: 4", "Full bathrooms: 3", "1/2 bathrooms: 2"],
  //       "basements": ["Basement: Heated,Garage Access,Storage Space"],
  //       "heating": ["Heating features: Forced Air, Radiator, Oil"],
  //       "cooling": ["Cooling features: Central Air"],
  //       "appliances": ["Appliances included: Electric Range, Wall Oven, Microwave, Range Hood, Refrigerator, Freezer, Dishwasher, Disposal, Washer, Dryer, Wine Cooler", "Laundry features: Private laundry room in unit, Main Level, Laundry Room"],
  //       "interior": ["Interior features: Wired for Sound, Elevator, Open Floorplan, Exercise Room, Foyer, Laundry Room"],
  //       "otherInterior": ["Common walls with other units/homes: End Unit", "Total interior livable area: 3,441 sqft", "Finished area above ground: 3,441", "Total number of fireplaces: 1", "Virtual tour: View virtual"],
  //       "parking": ["Total spaces: 2", "Parking features: Unit Garage, Assigned, Secured", "Garage spaces: 2"],
  //       "accesability": ["Accessibility features: Accessible Doors, Accessible Hallway(s)"],
  //       "property": ["Levels: 1", "Stories: 1", "Exterior features: Awning(s), Garden, Barbecue, Lighting"],
  //       "lot": ["Lot features: Historic District, Level, Lightly Wooded, Fruit Trees"],
  //     }
  //   };

    const handleOpenModalImageGallery = () => {   
      const PHOTOS: string[] = modalPropertyData?.galleryImgs  || [];
      const featuredImage = modalPropertyData?.featuredImage;
      const newPhotos = [featuredImage, ...PHOTOS];
      const filteredPhotos = newPhotos.filter((item) => typeof item === 'string');
    
      setPropertyImage(
       filteredPhotos.map((item, index): ListingGalleryImage => {
         return {
           id: index,
           url: typeof item === 'string' ? item : '', 
         };
       })
     );
        setIsOpenGallery(true);
     };
    
     const renderGallery = () => {
      return (
          <div className="flex flex-col ">
             
              <div className="relative flex-col w-full h-[400px] rounded-sm overflow-hidden cursor-pointer bg-[white] mb-[2px]">
                  <img
                    className="absolute inset-0 object-cover rounded-sm sm:rounded-sm w-full h-full"
                    src={modalPropertyData?.featuredImage}
                    alt=""
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
                    onClick={handleOpenModalImageGallery}
                  />
              {/* <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div> */}
            </div>
          <div className=" grid grid-cols-2 gap-[2px] scroll-top-0  ">
            
            {modalPropertyData?.galleryImgs?.map((item, index) => (
              <div
                key={index}
                onClick={handleOpenModalImageGallery}
                className={`relative rounded-sm overflow-hidden ${
                  index >= 3 ? "hidden sm:block" : ""
                }`}
              >
                <div className="aspect-w-6 aspect-h-3 sm:aspect-w-6 sm:aspect-h-3">
                  <img
                    className="absolute inset-0 object-cover rounded-sm  w-full h-full"
                    src={item || ""}
                    alt=""
                    
                  />
                </div>
    
                {/* OVERLAY */}
                <div
                  className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                  
                />
              </div>
            ))}
    
            {/* <button
              className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 hover:bg-neutral-200 z-10"
              
            >
              <Squares2X2Icon className="w-5 h-5" />
              <span className="ml-2 text-neutral-800 text-sm font-medium">
                Show all photos
              </span>
            </button> */}
          </div>
         </div>
          );
          };
    
          const renderTienIch = () => {
            return (
              <div className="inline-grid grid-cols-3 gap-2 py-[10px]">
                <div className="flex items-center space-x-2">
                  <span className="hidden sm:inline-block">
                    <i className="las la-bed text-lg"></i>
                  </span>
                  <span className="text-xs text-neutral-500 dark:text-neutral-400">
                    {modalPropertyData?.bedrooms} beds
                  </span>
                </div>
        
                {/* ---- */}
                <div className="flex items-center space-x-2">
                  <span className="hidden sm:inline-block">
                    <i className="las la-bath text-lg"></i>
                  </span>
                  <span className="text-xs text-neutral-500 dark:text-neutral-400">
                  {modalPropertyData?.bathrooms} baths
                  </span>
                </div>
        
                {/* ---- */}
                <div className="flex items-center space-x-2">
                  <span className="hidden sm:inline-block">
                    <i className="las la-expand-arrows-alt text-lg"></i>
                  </span>
                  <span className="text-xs text-neutral-500 dark:text-neutral-400">
                  {modalPropertyData?.sqrft} Sq. Fit
                  </span>
                </div>
              </div>
            );
          };
    
          const renderMainFeatures = (features: string[] | undefined) => {
            // const features = propertyObject.mainFeatures
            if (!features) {
              return null; // or <div>No data available</div> or any other alternative
            }
            return (
              <div className="flex flex-col">
                {features.map((data, index) => (
                  <div key={index} className="flex flex-row">
                    {index % 2 === 0 && (
                      <>
                        <div className="flex-col prose sm:prose w-1/2">
                          <ul className="text-xs text-left">
                            <li>{data}</li>
                          </ul>
                        </div>
                        {features[index + 1] && (
                          <div className="flex-col prose sm:prose w-1/2">
                            <ul className="text-xs text-left">
                              <li>{features[index + 1]}</li>
                            </ul>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                ))}
              </div>
            );
          };
    
          const renderSidebar = () => {
            return (
              <div className="py-[20px] ">
                
                <div className="flex justify-between pb-[10px] ">
                  <span className="text-3xl ">
                   
                  {modalPropertyData?.price}
                  </span>
                </div>
                <div className="flex flex-col ">
                  <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
                    {renderTienIch()}
                  </div>
                  <div className="flex flex-col  pt-[5px] pb-[20px]">
                {/* {isAds && <Badge name="ADS" color="green" />} */}
                <h2 className="flex justify-left text-sm font-medium capitalize">
                  <span className="line-clamp-2">{modalPropertyData?.title}</span>
                </h2>
                <div className="flex justify-left text-sm font-light pt-[5px]">
                  {modalPropertyData?.address}
                </div>
              </div>
                   {/* host */}
                    <div className="flex items-center space-x-4 pt-[20px] pl-[35px]">
                          <Avatar
                            hasChecked
                            hasCheckedClass="w-4 h-4 -top-0.5 right-0.5"
                            sizeClass="h-20 w-20"
                            radius="rounded-full"
                            imgUrl={modalPropertyData?.author?.avatar}
                          />
                          <div >
                              {/* <a className=" text-md font-medium flex justify-left hover:no-underline" href="/author">
                              {modalPropertyData?.author.firstName} {modalPropertyData?.author.lastName}
                              </a> */}
                              <Link className=" text-md font-medium flex justify-left" to="/author" state= {author}>
                                     {modalPropertyData?.author?.firstName} {modalPropertyData?.author?.lastName}
                                  </Link>
    
                              <div className=" flex items-center text-sm text-neutral-500 dark:text-neutral-400">
                                {/* <StartRating /> */}
                                <FiveStartIconForRate iconClass="w-4 h-4 " className="space-x-0.5" defaultPoint={modalPropertyData?.author?.reviewStart}/>
                                <span className="mx-2">·</span>
                              </div>
                          </div>
                          
                    </div>
                    <div className="flex flex-row justify-left  pt-[30px]">
                        <div className="flex-col pr-[20px]">
                                <ButtonSquareFull onClick={openModalTour} className="bg-[#16385D] text-sm font-medium text-[white] px-[22px]"
                                  size="h-11" >
                              Request a Tour
                              </ButtonSquareFull>
                        </div>
                           <div className="flex-col">
                              <ButtonSquareFull onClick={openModalContact} className="bg-[white] border border-[#16385D] text-sm font-medium text-[#16385D] px-[22px]"
                                  size="h-11" >
                              Contact Agent
                              </ButtonSquareFull>
                           </div>  
                           {renderModalTour()}  
                           {renderModalContact()}  
                     </div>
                     <div className="pt-[30px] ">
                     {renderMainFeatures(modalPropertyData?.mainFeatures)}
                     </div>
                       
                          
    
                       <div className="grid grid-cols-1 gap-3 mt-[35px] pb-[20px] ">
                          <div className="   rounded-lg bg-[#E3F3FF] ">
                            <Overview className="flex flex-col " overview={modalPropertyData?.overview} author={modalPropertyData?.author} />
                          </div>
                          <div className="  rounded-lg bg-[#E3F3FF]">
                            <FactsFeatures className="flex flex-col" facts={modalPropertyData?.factsFeatures}/>
                            {/* <Overview className="flex flex-col " uniqueClassName="PageHome2_s2"/> */}
                          </div>
                          <div className=" rounded-lg bg-[#E3F3FF]">
                            {/* <ContactAgent className="flex " /> */}
                            {/* <Overview className="flex flex-col " uniqueClassName="PageHome2_s2" /> */}
                          </div>
                          {/* {DEMO_DATA.map((item, index) => (
                            <FlightCard defaultOpen={!index} key={index} data={item} />
                          ))} */}
                      </div>
                    </div>
                {/* </div> */}
        
                {/* SUBMIT */}
                {/* <ButtonPrimary href={"/checkout"}>Reserve</ButtonPrimary> */}
              </div>
            );
          };
    
    
          const renderModalTour = () => {
            return (
              <Transition appear show={isOpenModalTour} as={Fragment}>
                <Dialog
                  as="div"
                  className="fixed inset-0 z-50 overflow-y-auto"
                  onClose={closeModalTour}
                >
                  <div className="min-h-screen px-4 text-center">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
                    </Transition.Child>
        
                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span
                      className="inline-block h-screen align-middle"
                      aria-hidden="true"
                    >
                      &#8203;
                    </span>
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0 scale-95"
                      enterTo="opacity-100 scale-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100 scale-100"
                      leaveTo="opacity-0 scale-95"
                    >
                      <div className="inline-block py-8 h-[600px] w-full max-w-sm">
                        <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white shadow-xl h-full">
                          <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                            <h3
                              className="text-md font-medium leading-6 text-gray-900"
                              id="headlessui-dialog-title-70"
                            >
                              Take a tour with a buyer's agent
                            </h3>
                            <span className="absolute left-3 top-3">
                              <ButtonClose onClick={closeModalTour} />
                            </span>
                          </div>
                          {/* <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200"> */}
                          <div className=" px-8  text-neutral-700  ">
                          <label className="block py-[15px]">
                             <Label>Tour type</Label>
                               <div className="flex justify-center w-full">
                                    <div className="inline-flex  rounded-lg py-[3px]" role="group">
                                      <button onClick={changeTypePerson} type="button" className={`w-[160px] py-3 text-xs font-medium  rounded-l-xl  ${isTypePerson ? "text-white bg-[#1A4676] " : "text-[#1A4676] bg-white border border-[#1A4676]"}`}>
                                        in-person
                                      </button>
                                      <button onClick={changeTypeVideo} type="button" className={`w-[160px] py-3 text-xs font-medium  rounded-r-xl ${isTypePerson ? "text-[#1A4676] bg-white border border-[#1A4676] " : "text-white bg-[#1A4676]"}`}>
                                        Video chat
                                      </button>
                                    </div>
                                </div>
                             </label> 
                                <div className="w-full">
                                   <label className="block">
                                      <Label>Tour date</Label>
                                           <DatePicker className="rounded-md w-[320px]"
                                            selected={startDate}
                                            onChange={(date) => setStartDate(date)}
                                            minDate={new Date()}
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={30}
                                            timeCaption="time"
                                            dateFormat="MMMM d, yyyy h:mm aa"
                                            placeholderText="Select date and time"
                                          />
                                     </label>                                        
                                </div>
                                <div>
                                      <form className="grid grid-cols-1 gap-6" >
                                        <label className="block pt-[20px]">
                                          <Label>Full name</Label>
    
                                          <Input
                                            placeholder="Type your full name"
                                            type="text"
                                            className="mt-1 rounded-md"
                                          />
                                        </label>
                                        <label className="block">
                                          <Label>Email address</Label>
    
                                          <Input
                                            type="email"
                                            placeholder="example@example.com"
                                            className="mt-1 rounded-md"
                                          />
                                        </label>
                                        {/* <label className="block">
                                          <Label>Message</Label>
    
                                          <Textarea className="mt-1" rows={6} />
                                        </label> */}
                                        <div>
                                          <button className="p-3 text-white font-medium  rounded-lg w-full bg-[#00D3DB]" type="submit">Request this time</button>
                                        </div>
                                      </form>
                                 </div>
                          </div>
                        </div>
                      </div>
                    </Transition.Child>
                  </div>
                </Dialog>
              </Transition>
            );
          };  
          
          const renderModalContact = () => {
            return (
              <Transition appear show={isOpenModalContact} as={Fragment}>
                <Dialog
                  as="div"
                  className="fixed inset-0 z-50 overflow-y-auto"
                  onClose={closeModalContact}
                >
                  <div className="min-h-screen px-4 text-center">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0"
                      enterTo="opacity-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
                    </Transition.Child>
        
                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span
                      className="inline-block h-screen align-middle"
                      aria-hidden="true"
                    >
                      &#8203;
                    </span>
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0 scale-95"
                      enterTo="opacity-100 scale-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100 scale-100"
                      leaveTo="opacity-0 scale-95"
                    >
                      <div className="inline-block py-8 h-[600px] w-full max-w-sm">
                        <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white shadow-xl h-full">
                          <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                            <h3
                              className="text-md font-medium leading-6 text-gray-900"
                              id="headlessui-dialog-title-70"
                            >
                              Contact buyer agent
                            </h3>
                            <span className="absolute left-3 top-3">
                              <ButtonClose onClick={closeModalContact} />
                            </span>
                          </div>
                          {/* <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200"> */}
                          <div className=" px-8  text-neutral-700  ">
                                <div>
                                      <form className="grid grid-cols-1 gap-6" >
                                        <label className="block pt-[20px]">
                                          <Label>Full name</Label>
    
                                          <Input
                                            placeholder="Type your full name"
                                            type="text"
                                            className="mt-1 rounded-md"
                                          />
                                        </label>
                                        <label className="block">
                                          <Label>Email address</Label>
    
                                          <Input
                                            type="email"
                                            placeholder="example@example.com"
                                            className="mt-1 rounded-md"
                                          />
                                        </label>
                                        <label className="block">
                                          <Label>Message</Label>
    
                                          <Textarea className="mt-1" rows={6} />
                                        </label>
                                        <div>
                                          <button className="p-3 text-white font-medium  rounded-lg w-full bg-[#00D3DB]" type="submit">Send</button>
                                        </div>
                                      </form>
                                 </div>
                          </div>
                        </div>
                      </div>
                    </Transition.Child>
                  </div>
                </Dialog>
              </Transition>
            );
          };  
   
    
    const renderModalDetails = () => {
      return (
        <Transition appear show={isOpenModalDetails} as={Fragment}>
          <Dialog
            as="div"
            className="fixed inset-0 z-50 overflow-y-auto"
            onClose={closeModalDetails}
          >
            <div className=" text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-xl backdrop-contrast-125 " />
              </Transition.Child>
    
              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="inline-block h-screen align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div className="inline-block  w-full max-w-6xl h-screen">
                  <div className="  flex flex-col lg:flex-row  h-full w-full overflow-hidden">
                    <div className="relative flex-col lg:w-3/5 w-full  space-y-8 lg:space-y-10 overflow-y-auto scroll-top-0 bg-[white]">
                    {renderGallery()}
                      
                    </div>
                   
                    <div className="flex-col bg-[white] lg:w-2/5 w-full ">
                        <div className=" h-[30px] bg-[#D9EEFF57]">
                      
                        </div>
                        <div className=" mx-[20px] h-full overflow-y-auto ">
                           {renderSidebar()}
    
                        </div>   
                    </div>
                   
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      );
    };

  return (
    // <CommonLayout
    //   nextBtnText="Send to review"
    //   index="5"
    //   backtHref="/add-listing-7"
    //   nextHref="/"
    // >
    //   <>
    <div
    className={`nc-PageAddListing2 px-4 max-w-3xl mx-auto pb-24 pt-14 sm:py-24 lg:pb-32`}
    data-nc-id="PageAddListing2"
  >
    <div className="space-y-11">
      <div>
        <span className="text-4xl font-semibold">5</span>{" "}
        <span className="text-lg text-neutral-500 dark:text-neutral-400">
          / 5
        </span>
      </div>
      <div className="listingSection__wrap ">
        <div>
          <h2 className="text-2xl font-semibold">Done</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
          When you submit the property for review, it usually takes 3 working days to be processed. You will receive an email with the status.
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* FORM */}
        <div>
          <h3 className="text-lg font-semibold">This is your listing</h3>
          <div className="max-w-xs">
            {/* <StayCard
              className="mt-8"
              data={{ ...DEMO_STAY_LISTINGS[0], reviewStart: 0 }}
            /> */}
             <PropertyCard className="h-full" data={property} onButtonClick={handleClick}/>
             {renderModalDetails()}
             {isOpenGallery && 
                 <Modal
                      images={propertyImage || []}
                      onClose={() => {
                      setIsOpenGallery(false);
                     }}
                 />
                }
          </div>
          <div className="flex items-center space-x-5 mt-8">
            <ButtonSecondary onClick={toEdit}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
              <span className="ml-3">Edit</span>
            </ButtonSecondary>

            {/* <ButtonPrimary>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                />
              </svg>
              <span className="ml-3">Preview</span>
            </ButtonPrimary> */}
          </div>
        </div>
        {/*  */}
        </div>
        <div className="flex justify-end space-x-5">
          <ButtonSecondary onClick={toPrevtStep}>Go back</ButtonSecondary>
          <ButtonPrimary onClick={toReview}> {"Send to review"} </ButtonPrimary>
        </div>
        </div>
      </div>
  );
};

export default PageAddListing10;
